import { Injectable, Component, NgZone, inject } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';
import { CircleAlert, CircleCheckBig, Info, LucideAngularModule, X } from 'lucide-angular';
import { MobileStore } from 'src/store/mobile.store';

@Component({
  selector: 'app-snackbar',
  templateUrl: '../snackbar/snackbar.template.html',
  imports: [LucideAngularModule],
})
export class MessageArchivedComponent {
  protected readonly data: {
    message: string;
    type: string;
    actionText: string;
    action: () => void;
  } = inject(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject(MatSnackBar);
  protected readonly CircleCheckBig = CircleCheckBig;
  protected readonly CircleAlert = CircleAlert;
  protected readonly Info = Info;
  protected readonly X = X;

  protected closeSnackBar() {
    this.snackBarRef.dismiss();
  }

  protected callAction() {
    if (this.data.action) {
      this.data.action();
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly _snackBar = inject(MatSnackBar);
  private readonly ngZone = inject(NgZone);
  private readonly mobileStore = inject(MobileStore);
  private DEFAULT_DURATION_SECONDS = 5;

  openSuccessSnackBar(
    message: string,
    actionText = '',
    actionFunction: (() => void) | null = null,
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
    verticalPosition: MatSnackBarVerticalPosition = 'top',
  ) {
    if (this.mobileStore.isMobile()) {
      return;
    }
    this._snackBar.openFromComponent(MessageArchivedComponent, {
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
      duration: this.DEFAULT_DURATION_SECONDS * 1000,
      panelClass: ['success-snackbar'],
      data: { message, type: 'success', actionText, action: actionFunction },
    });
  }

  openErrorSnackBar(
    message: string,
    actionText = '',
    actionFunction: (() => void) | null = null,
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
    verticalPosition: MatSnackBarVerticalPosition = 'top',
  ) {
    if (this.mobileStore.isMobile()) {
      return;
    }
    this._snackBar.openFromComponent(MessageArchivedComponent, {
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
      duration: this.DEFAULT_DURATION_SECONDS * 1000,
      panelClass: ['danger-snackbar'],
      data: { message, type: 'warning', actionText, action: actionFunction },
    });
  }

  handleError(
    message: string,
    actionText = '',
    actionFunction: (() => void) | null = null,
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
    verticalPosition: MatSnackBarVerticalPosition = 'top',
  ) {
    if (this.mobileStore.isMobile()) {
      return;
    }
    this.ngZone.run(() => {
      setTimeout(() => {
        this._snackBar.openFromComponent(MessageArchivedComponent, {
          horizontalPosition: horizontalPosition,
          verticalPosition: verticalPosition,
          duration: this.DEFAULT_DURATION_SECONDS * 1000,
          panelClass: ['info-snackbar'],
          data: { message, type: 'info', actionText, action: actionFunction },
        });
      }, 0);
    });
  }
}
